module.exports = __webpack_public_path__ + "static/media/iconClassesActive.1312072d.svg";